const localePrefix = window.location.pathname.match(/^\/(?<locale>[a-z]{2}(?:-[A-Z]{2})?)(?=\/|$)/)?.groups?.locale || '';
const apiPath = localePrefix ? `/${localePrefix}/api/app` : '/api/app';

export const createCartRequest = async () => {
  const response = await fetch(`${apiPath}/carts`, {
    method: 'POST'
  })

  if (response.status === 201) {
    return await response.json();
  } else {
    return {data: null};
  }
};

export const getCart = async (cart) => {
  if (!cart) return {data: null};

  const response = await fetch(`${apiPath}/carts/${cart.id}?token=${cart.token}`, {
    method: 'GET'
  })

  if (response.status === 200) {
    return await response.json();
  } else {
    return {data: null};
  }
};

export const getDeliveryServices = async () => {
  const response = await fetch(`${apiPath}/delivery_services`, {
    method: 'GET'
  })

  if (response.status === 200) {
    return await response.json();
  } else {
    return {items: []};
  }
};

export const getPaymentServices = async () => {
  const response = await fetch(`${apiPath}/payment_services`, {
    method: 'GET'
  })

  if (response.status === 200) {
    return await response.json();
  } else {
    return {items: []};
  }
};

export const updateCart = async (cartId, payload) => {
  return await fetch(`${apiPath}/carts/${cartId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
};

export const createCartItem = async (cart, productId, panacea_data, quantity = 1) => {
  if (!cart) return {status: 404};

  return await fetch(`${apiPath}/carts/${cart.id}/cart_items`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      product_id: productId,
      token: cart.token,
      quantity: quantity,
      panacea_data: panacea_data
    })
  }).then(handleResponse)
}

export const updateCartItem = async (id, itemId, payload) => {
  return await fetch(`${apiPath}/carts/${id}/cart_items/${itemId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
};

export const removeCartItem = async (id, itemId, token) => {
  return fetch(`${apiPath}/carts/${id}/cart_items/${itemId}?token=${token}`, {
    method: 'DELETE'
  })
};

export const handleResponse = async (response) => {
  const contentType = response.headers.get("content-type");
  let result;

  if (contentType && contentType.indexOf("application/json") !== -1) {
    const data = await response.json();
    result = { status: response.status, ...data };
  } else {
    result = { status: response.status };
  }

  if (!response.ok) {
    throw new Error(JSON.stringify(result));
  }

  return result;
};

export const showErrors = (error) => {
  try {
    JSON.parse(error.message);
  } catch(e) {
    alert(error.message);
  }
}
